// extracted by mini-css-extract-plugin
module.exports = {"ion-list":"ChartList_ion-list__SSiar","add-button":"ChartList_add-button__Q_ES4"};